export default "__VITE_ASSET__D8p0NIS8__"